import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { useMember, mayCreateResource } from '@/lib/use-session';
import { LearningTrackDetailView } from '@/components/learning-tracks/LearningTrackDetailView';

export const Route = createFileRoute(
  '/_public/resources/learning-tracks/$trackId/',
)({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.trackId)) throw notFound();
  },
  component: LearningTrackDetailPage,
});

function LearningTrackDetailPage() {
  const { trackId } = Route.useParams();
  const me = useMember();
  const canManage = me !== null && mayCreateResource(me.platformRole);
  return (
    <LearningTrackDetailView trackId={trackId} canManage={canManage} />
  );
}
